import React, { useState, useEffect } from "react";
import Form from "react-bootstrap/Form";
import "./LibraryDetail.css";
import axios from "../../axios";
import LibrarySubjectProps from "./LibrarySubject/LibrarySubjectProps";
import { toast } from "react-toastify";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
} from "@mui/material";
import { Clear } from "@mui/icons-material";

export default function LibraryDetail({ setActiveHeader, setCreate }) {
  const [openSubject, setOpenSubject] = useState({});
  const [classSectionVal, setClassSectionVal] = useState([]);
  const [filter, setFilter] = useState({
    standard_id: "",
    section_id: "",
    standardName: "",
    sectionName: "",
  });

  let general_role = localStorage.getItem("general_role");
  let generalRole_JSON =
    JSON.parse(general_role) == null ? [] : JSON.parse(general_role);
  let classTeacher = localStorage.getItem("role_as_class_teacher");
  let classTeacher_JSON =
    JSON.parse(classTeacher) == null ? [] : JSON.parse(classTeacher);
  let cordinator = localStorage.getItem("role_as_co_ordinator");
  let cordinator_JSON =
    JSON.parse(cordinator) === null ? [] : JSON.parse(cordinator);

  useEffect(() => {
    if (filter.standardName === null && filter.standard_id === null) {
      setFilter({
        ...filter,
        section_id: null,
        sectionName: null,
      });
    }
  }, [filter.standardName]);
  const handelSesionSubject = (index) => {
    setOpenSubject((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };
  useEffect(() => {
    function extractSectionAndStandardInfo() {
      const resultArray = [];
      generalRole_JSON.forEach((obj) => {
        const sectionId = obj.section_id.id;
        const sectionName = obj.section_id.name;
        const standardId = obj.standard_id.id;
        let standardName = obj.standard_id.name;
        standardName = standardName.replace(/\s*(st|nd)\b/gi, "");
        const existingEntry = resultArray.find(
          (entry) =>
            entry.sectionId === sectionId && entry.standardId === standardId
        );

        if (!existingEntry) {
          resultArray.push({
            sectionId,
            sectionName,
            standardId,
            standardName,
          });
        }
      });
      classTeacher_JSON.forEach((obj) => {
        const sectionId = obj.section_id.id;
        const sectionName = obj.section_id.name;
        const standardId = obj.standard_id.id;
        let standardName = obj.standard_id.name;
        standardName = standardName.replace(/\s*(st|nd)\b/gi, "");
        const existingEntry = resultArray.find(
          (entry) =>
            entry.sectionId === sectionId && entry.standardId === standardId
        );

        if (!existingEntry) {
          resultArray.push({
            sectionId,
            sectionName,
            standardId,
            standardName,
          });
        }
      });
      cordinator_JSON.forEach((obj) => {
        const sectionId = obj.section_id.id;
        const sectionName = obj.section_id.name;
        const standardId = obj.standard_id.id;
        let standardName = obj.standard_id.name;
        standardName = standardName.replace(/\s*(st|nd)\b/gi, "");
        const existingEntry = resultArray.find(
          (entry) =>
            entry.sectionId === sectionId && entry.standardId === standardId
        );

        if (!existingEntry) {
          resultArray.push({
            sectionId,
            sectionName,
            standardId,
            standardName,
          });
        }
      });
      resultArray.sort((a, b) => {
        if (a.standardName === b.standardName) {
          return a.sectionName.localeCompare(b.sectionName);
        }
        return a.standardName.localeCompare(b.standardName);
      });
      setClassSectionVal(resultArray);
    }
    extractSectionAndStandardInfo();
  }, []);
  let sectionArr = [];
  let standardArr = [];
  let uniqueStandardSectionIds = [];
  const handleSectionStandard = () => {
    generalRole_JSON.forEach((item) => {
      const standardId = item.standard_id.id;
      const standardName = item.standard_id.name;
      const sectionId = item.section_id.id;
      const sectionName = item.section_id.name;
      const standardSectionObj = {
        standardId,
        standardName,
        sectionId,
        sectionName,
      };

      const isDuplicate = uniqueStandardSectionIds.some((item) => {
        return item.standardId === standardId && item.sectionId === sectionId;
      });

      if (!isDuplicate) {
        uniqueStandardSectionIds.push(standardSectionObj);
      }
    });
    classTeacher_JSON.forEach((item) => {
      const standardId = item.standard_id.id;
      const standardName = item.standard_id.name;
      const sectionId = item.section_id.id;
      const sectionName = item.section_id.name;
      const standardSectionObj = {
        standardId,
        standardName,
        sectionId,
        sectionName,
      };

      const isDuplicate = uniqueStandardSectionIds.some((item) => {
        return item.standardId === standardId && item.sectionId === sectionId;
      });

      if (!isDuplicate) {
        uniqueStandardSectionIds.push(standardSectionObj);
      }
    });
    cordinator_JSON.forEach((item) => {
      const standardId = item.standard_id.id;
      const standardName = item.standard_id.name;
      const sectionId = item.section_id.id;
      const sectionName = item.section_id.name;
      const standardSectionObj = {
        standardId,
        standardName,
        sectionId,
        sectionName,
      };

      const isDuplicate = uniqueStandardSectionIds.some((item) => {
        return item.standardId === standardId && item.sectionId === sectionId;
      });

      if (!isDuplicate) {
        uniqueStandardSectionIds.push(standardSectionObj);
      }
    });
  };
  handleSectionStandard();

  const dropDownHelper = () => {
    function addUniqueObjectToArraystand(obj) {
      if (
        !standardArr.some(
          (item) => JSON.stringify(item) === JSON.stringify(obj)
        )
      ) {
        standardArr.push(obj);
      }
    }
    generalRole_JSON?.map((obj) =>
      addUniqueObjectToArraystand(obj.standard_id)
    );
    classTeacher_JSON?.map((obj) =>
      addUniqueObjectToArraystand(obj.standard_id)
    );
    cordinator_JSON?.map((obj) => addUniqueObjectToArraystand(obj.standard_id));
  };
  dropDownHelper();
  const handleDropDownSec = () => {
    function addUniqueObjectToArraysect(obj) {
      if (
        !sectionArr.some((item) => JSON.stringify(item) === JSON.stringify(obj))
      ) {
        sectionArr.push(obj);
      }
    }

    const selectedStandardId = filter.standard_id;

    generalRole_JSON?.forEach((obj) => {
      if (obj?.standard_id?.id === selectedStandardId) {
        addUniqueObjectToArraysect(obj.section_id);
      }
    });
    classTeacher_JSON?.forEach((obj) => {
      if (obj?.standard_id?.id === selectedStandardId) {
        addUniqueObjectToArraysect(obj.section_id);
      }
    });
    cordinator_JSON?.forEach((obj) => {
      if (obj?.standard_id?.id === selectedStandardId) {
        addUniqueObjectToArraysect(obj.section_id);
      }
    });
  };
  function extractIdFromString(inputString) {
    const parts = inputString.split(",");
    const id = parts[0]?.trim();
    return id;
  }
  function extractNameFromString(inputString) {
    const parts = inputString.split(",");
    const id = parts[1]?.trim();
    return id;
  }
  handleDropDownSec();
  const [apiResponses, setApiResponses] = useState([]);
  let timeTableSessionId = JSON.parse(
    localStorage.getItem("timeTableSessionId")
  );
  const handleAPICallAndSaveResponse = async (obj, index, type) => {
    if (!timeTableSessionId) {
      toast.error(
        "These are no allocations set for your login. Please contact school admin for the assistance."
      );
      return;
    }
    try {
      let res;
      if (type === "normal") {
        const isGeneralTeacher = hasMatchingSectionAndStandard(
          generalRole_JSON,
          obj.sectionId,
          obj.standardId
        );
        res = await axios.get(
          `/api/v1/cm/library/book/getSubjectByClassSection?standard_id=${obj?.standardId}&section_id=${obj?.sectionId}&timetable_session=${timeTableSessionId}`
        );
        if (isGeneralTeacher) {
          let updatedArray = filterSubjectsByArray(
            generalRole_JSON,
            res.data.data
          );
          const updatedResponses = [...apiResponses];
          updatedResponses[index] = updatedArray;
          setApiResponses(updatedResponses);
        } else {
          const updatedResponses = [...apiResponses];
          updatedResponses[index] = res.data.data;
          setApiResponses(updatedResponses);
        }
      }
      if (type === "unique") {
        const isGeneralTeacher = hasMatchingSectionAndStandard(
          generalRole_JSON,
          obj.section_id,
          obj.standard_id
        );
        res = await axios.get(
          `/api/v1/cm/library/book/getSubjectByClassSection?standard_id=${obj?.standard_id}&section_id=${obj?.section_id}&timetable_session=${timeTableSessionId}`
        );
        if (isGeneralTeacher) {
          let updatedArray = filterSubjectsByArray(
            generalRole_JSON,
            res.data.data
          );
          const updatedResponses = [...apiResponses];
          updatedResponses[index] = updatedArray;
          setApiResponses(updatedResponses);
        } else {
          const updatedResponses = [...apiResponses];
          updatedResponses[index] = res.data.data;
          setApiResponses(updatedResponses);
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  function hasMatchingSectionAndStandard(
    objectsArray,
    sectionIdToMatch,
    standardIdToMatch
  ) {
    return objectsArray.some((obj) => {
      return (
        obj.section_id.id === sectionIdToMatch &&
        obj.standard_id.id === standardIdToMatch
      );
    });
  }
  function filterSubjectsByArray(firstArray, secondArray) {
    const matchingSubjectsIds = new Set(
      firstArray.flatMap((subject) => subject.subjects_id.map((sub) => sub.id))
    );
    const updatedSecondArray = secondArray.filter((item) =>
      matchingSubjectsIds.has(item.subjectId.id)
    );
    return updatedSecondArray;
  }
  const [filterHistory, setFilterHistory] = useState([filter]);
  useEffect(() => {
    const updatedFilter = {
      ...filter,
      standardName: filter.standardName
        ? filter.standardName.replace(/\s*(st|nd)\b/gi, "")
        : null,
    };
    setFilterHistory([updatedFilter]);
  }, [filter]);
  useEffect(() => {
    // Retrieve saved values from local storage
    const savedStandardId = localStorage.getItem("selectedStandardIdLibrary");
    const savedStandardName = localStorage.getItem(
      "selectedStandardNameLibrary"
    );
    const savedSectionId = localStorage.getItem("selectedSectionIdLibrary");
    const savedSectionName = localStorage.getItem("selectedSectionNameLibrary");
    if (
      savedStandardId !== undefined &&
      savedStandardName &&
      savedSectionId &&
      savedSectionName
    ) {
      setFilter({
        ...filter,
        standard_id: savedStandardId,
        standardName: savedStandardName,
        section_id: savedSectionId,
        sectionName: savedSectionName,
      });
    }
  }, []);
  useEffect(() => {
    if (
      filterHistory[0].standard_id !== "" &&
      filterHistory[0].section_id !== ""
    ) {
      console.log("Second");
      handelSesionSubject(0);
      handleAPICallAndSaveResponse(filterHistory[0], 0, "unique");
    } else if (classSectionVal.length > 0) {
      handelSesionSubject(0);
      handleAPICallAndSaveResponse(classSectionVal[0], 0, "normal");
    }
  }, [classSectionVal, filterHistory]);

  // useEffect(() => {
  //   if (classSectionVal.length > 0) {
  //     // Run this by default when classSectionVal is present and filterHistory is not set
  //     handelSesionSubject(0);
  //     console.log("first")
  //     handleAPICallAndSaveResponse(classSectionVal[0], 0, "normal");
  // } else if (filterHistory.length > 0) {
  //   handelSesionSubject(0);
  //   console.log("Second")
  //   handleAPICallAndSaveResponse(filterHistory[0], 0, "unique");
  // }
  // }, [classSectionVal, filterHistory]);
  return (
    <>
      <div className="d-flex justify-content-end">
        <div className="mb-3 p-0 gap-3 d-flex dropdownSize">
          <FormControl fullWidth variant="outlined" size="small">
            <InputLabel>Select Class</InputLabel>
            <Select
              label="Select Class"
              id="Live_dropdown_CM"
              value={filter.standard_id || ""}
              onChange={(e) => {
                const selectedStandardId = e.target.value;
                const selectedStandard = standardArr.find(
                  (obj) => obj.id === selectedStandardId
                );

                localStorage.setItem(
                  "selectedStandardIdLibrary",
                  selectedStandardId
                );
                localStorage.setItem(
                  "selectedStandardNameLibrary",
                  selectedStandard?.name || ""
                );
                localStorage.setItem("LibraryNav", JSON.stringify([]));

                setFilter({
                  ...filter,
                  standard_id: selectedStandardId,
                  standardName: selectedStandard?.name || null,
                });

                setOpenSubject([]);
                setApiResponses([]);
              }}
            >
              <MenuItem value="">Select All</MenuItem>

              {standardArr?.length > 0 &&
                [...standardArr]
                  .sort((a, b) => {
                    const aNum = Number(a.name);
                    const bNum = Number(b.name);

                    const bothNumeric = !isNaN(aNum) && !isNaN(bNum);
                    if (bothNumeric) {
                      return aNum - bNum; // numeric sort
                    }

                    return a.name.localeCompare(b.name); // alphabetical sort
                  })
                  .map((standard, index) => (
                    <MenuItem
                      key={index}
                      value={standard?.id}
                      name={standard?.name}
                    >
                      {standard?.name}
                    </MenuItem>
                  ))}
            </Select>
          </FormControl>

          <FormControl fullWidth size="small" variant="outlined">
            <InputLabel>Select Section</InputLabel>
            <Select
              label="Select Section"
              id="Live_dropdown_CM"
              value={filter.section_id || ""}
              onChange={(e) => {
                const selectedSectionId = e.target.value;
                const selectedSection = sectionArr.find(
                  (obj) => obj.id === selectedSectionId
                );

                localStorage.setItem(
                  "selectedSectionIdLibrary",
                  selectedSectionId
                );
                localStorage.setItem(
                  "selectedSectionNameLibrary",
                  selectedSection?.name || ""
                );
                localStorage.setItem("LibraryNav", JSON.stringify([]));

                setFilter({
                  ...filter,
                  section_id: selectedSectionId,
                  sectionName: selectedSection?.name || null,
                });

                setOpenSubject([]);
                setApiResponses([]);
              }}
            >
              <MenuItem value="">Select All</MenuItem>
              {sectionArr.map((obj) => (
                <MenuItem key={obj.id} value={obj.id}>
                  {obj.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
      </div>
      <div
        className="orange-scrollBar"
        style={{ height: "calc(100vh - 180px)", overflowY: "scroll" }}
      >
        {classSectionVal.length > 0 && !filter.sectionName ? (
          classSectionVal.map((obj, index) => (
            <>
              <div
                key={index}
                onClick={() => {
                  handelSesionSubject(index);
                  handleAPICallAndSaveResponse(obj, index, "normal");
                }}
                className="py-1 px-2 mt-2 d-flex align-items-center justify-content-between  total_days_drodown"
              >
                <div className="date_detail">
                  Class {obj.standardName} {obj.sectionName}
                </div>
                <img
                  src="/ContentM_images/downArrow.svg"
                  alt="arrow logo"
                  className={`${
                    openSubject[index]
                      ? "rotate_main_cm_arrow"
                      : "main_cm_arrow"
                  }`}
                ></img>
              </div>
              {openSubject[index] && (
                <div
                  className="mb-4 mt-2 subject_cm_card_container-new"
                  onClick={() => {
                    localStorage.setItem("LibraryIndex", index);
                  }}
                >
                  <LibrarySubjectProps
                    data={apiResponses[index]}
                    index={index}
                  />
                </div>
              )}
            </>
          ))
        ) : (
          <>
            {filterHistory.map((obj, index) => (
              <>
                <div
                  key={index}
                  onClick={() => {
                    handelSesionSubject(index);
                    handleAPICallAndSaveResponse(obj, index, "unique");
                  }}
                  className="py-1 px-2 mt-2 d-flex align-items-center justify-content-between  total_days_drodown"
                >
                  <div className="date_detail">
                    Class {obj.standardName} {obj.sectionName}
                  </div>
                  <img
                    src="/ContentM_images/downArrow.svg"
                    alt="arrow logo"
                    className={`${
                      openSubject[index]
                        ? "rotate_main_cm_arrow"
                        : "main_cm_arrow"
                    }`}
                  ></img>
                </div>
                {openSubject[index] && (
                  <div
                    className="mb-4 mt-2 subject_cm_card_container-new"
                    onClick={() => {
                      localStorage.setItem("LibraryIndex", index);
                    }}
                  >
                    <LibrarySubjectProps
                      data={apiResponses[index]}
                      index={index}
                    />
                  </div>
                )}
              </>
            ))}
          </>
        )}
      </div>
    </>
  );
}
